import { COLOR_PRIMARY_2 } from 'src/utils/colors';

export const styles = {
  ctaButton: {
    backgroundColor: COLOR_PRIMARY_2,
    color: 'white',
    borderRadius: '8px',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 500,
    px: 3,
    py: 1,
    '&:hover': {
      backgroundColor: COLOR_PRIMARY_2 + 'AA',
    },
  },
};
